import React from "react";

import ptBr from "../../../config/texts/pt-br";
import Styles from "../styles";
import { masks } from "../../../utils";
import { Grid } from "@material-ui/core";


function ModalView({ item }) {
  const texts = ptBr.login;

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(250px, 26vw, 500px)",
          paddingInline: "25px",
          marginBottom: "20px",
        }}
      >
        <Grid alignItems="flex-end" container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
           <Styles.ConteudoContainer>
              <Styles.Label>NOME DA PROPRIEDADE</Styles.Label>
              <Styles.Value>{item?.place?.name || item?.name }</Styles.Value>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
              <Styles.Label>ID</Styles.Label>
              <Styles.Value>{item?.place?.id || item?.id }</Styles.Value>
            </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>UF</Styles.Label>
            <Styles.Value>{item?.place?.address?.state ||item?.address?.state }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>{" "}
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>CIDADE</Styles.Label>
            <Styles.Value>{item?.place?.address?.city || item?.address?.city }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>{" "}
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>CEP</Styles.Label>
            <Styles.Value>{masks.CEP(item?.place?.address?.cep ||item?.address?.cep) }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>LOGRADOURO</Styles.Label>
            <Styles.Value>{item?.place?.address?.street || item?.address?.street }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>BAIRRO</Styles.Label>
            <Styles.Value>{item?.place?.address?.district || item?.address?.district }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={6} md={3} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>Nº</Styles.Label>
            <Styles.Value>{item?.place?.address?.number ||  item?.address?.number }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>
          <Grid item xs={6} md={3} lg={4}>
            <Styles.ConteudoContainer>
            <Styles.Label>COMPLEMENTO</Styles.Label>
            <Styles.Value>{item?.place?.address?.complement || item?.address?.complement }</Styles.Value>
          </Styles.ConteudoContainer>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ModalView;
